import { render, staticRenderFns } from "./ProfileTagsView.vue?vue&type=template&id=980bf31e&functional=true&"
import script from "./ProfileTagsView.vue?vue&type=script&lang=ts&"
export * from "./ProfileTagsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports